module.exports = __webpack_public_path__ + "static/media/gris_numero_oficina.1dc9bce7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/gris_numero_oficina.svg
// module id = 1753
// module chunks = 0